import { render, staticRenderFns } from "./StaticNTModal.vue?vue&type=template&id=6d01ea24&scoped=true"
import script from "./StaticNTModal.vue?vue&type=script&lang=js"
export * from "./StaticNTModal.vue?vue&type=script&lang=js"
import style0 from "./StaticNTModal.vue?vue&type=style&index=0&id=6d01ea24&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d01ea24",
  null
  
)

export default component.exports